import classNames from 'classnames';
import React, {useCallback, useContext, useEffect, useState} from 'react';
import useKeyPress from '../../../hooks/useKeyPress';
import styles from './textNumber.module.css';
import ArrowUp from '../../../assets/images/arrow_up.png';
import ArrowDown from '../../../assets/images/arrow_down.png';
import CommandsContext from '../../../context/commandsContext';

export const specialCharTextNumbers = [
  {id: 0, name: ''},
  {id: 1, name: 'A'},
  {id: 2, name: 'B'},
  {id: 3, name: 'C'},
  {id: 4, name: 'D'},
  {id: 5, name: 'E'},
  {id: 6, name: 'F'},
  {id: 7, name: 'G'},
  {id: 8, name: 'H'},
  {id: 9, name: 'I'},
  {id: 10, name: 'J'},
  {id: 11, name: 'K'},
  {id: 12, name: 'L'},
  {id: 13, name: 'M'},
  {id: 14, name: 'N'},
  {id: 15, name: 'O'},
  {id: 16, name: 'P'},
  {id: 17, name: 'Q'},
  {id: 18, name: 'R'},
  {id: 19, name: 'S'},
  {id: 20, name: 'T'},
  {id: 21, name: 'U'},
  {id: 22, name: 'V'},
  {id: 23, name: 'W'},
  {id: 24, name: 'X'},
  {id: 25, name: 'Y'},
  {id: 26, name: 'Z'},
  {id: 27, name: 'a'},
  {id: 28, name: 'b'},
  {id: 29, name: 'c'},
  {id: 30, name: 'd'},
  {id: 31, name: 'e'},
  {id: 32, name: 'f'},
  {id: 33, name: 'g'},
  {id: 34, name: 'h'},
  {id: 35, name: 'i'},
  {id: 36, name: 'j'},
  {id: 37, name: 'k'},
  {id: 38, name: 'l'},
  {id: 39, name: 'm'},
  {id: 40, name: 'n'},
  {id: 41, name: 'o'},
  {id: 42, name: 'p'},
  {id: 43, name: 'q'},
  {id: 44, name: 'r'},
  {id: 45, name: 's'},
  {id: 46, name: 't'},
  {id: 47, name: 'u'},
  {id: 48, name: 'v'},
  {id: 49, name: 'w'},
  {id: 50, name: 'x'},
  {id: 51, name: 'y'},
  {id: 52, name: 'z'},
  {id: 53, name: `'`},
  {id: 54, name: '0'},
  {id: 55, name: '1'},
  {id: 56, name: '2'},
  {id: 57, name: '3'},
  {id: 58, name: '4'},
  {id: 59, name: '5'},
  {id: 60, name: '6'},
  {id: 61, name: '7'},
  {id: 62, name: '8'},
  {id: 63, name: '9'},
  {id: 64, name: '.'},
  {id: 65, name: ','},
  {id: 66, name: '!'},
  {id: 67, name: '@'},
  {id: 68, name: '#'},
  {id: 69, name: '$'},
  {id: 70, name: '%'},
  {id: 71, name: '^'},
  {id: 72, name: '&'},
  {id: 73, name: '*'},
  {id: 74, name: '('},
  {id: 75, name: ')'},
  {id: 76, name: '-'},
  {id: 77, name: '_'},
  {id: 78, name: '+'},
  {id: 79, name: '='},
];

export const numbers = [
  {id: 0, name: ''},
  {id: 1, name: 'f'},
  {id: 2, name: '0'},
  {id: 3, name: '1'},
  {id: 4, name: '2'},
  {id: 5, name: '3'},
  {id: 6, name: '4'},
  {id: 7, name: '5'},
  {id: 8, name: '6'},
  {id: 9, name: '7'},
  {id: 10, name: '8'},
  {id: 11, name: '9'},
  {id: 12, name: '.'},
  {id: 13, name: '-'},
  {id: 14, name: ','},
];

function TextNumbers({style, chars, onChange, defaultKey, isDisabled}) {
  const [selected, setSelected] = useState(defaultKey);
  const downPress = useKeyPress('ArrowDown');
  const upPress = useKeyPress('ArrowUp');
  const {onUpdateCommands} = useContext(CommandsContext);

  const onUp = useCallback(() => {
    const upValue = selected + 1;
    const index = upValue === chars.length ? 2 : upValue;

    setSelected(index);
  }, [selected]);

  const onDown = useCallback(() => {
    let index = selected - 1;

    const maxIndex = chars.length;
    if (index === -1) {
      index = maxIndex - 1;
    }
    setSelected(index);
  }, [selected]);

  useEffect(() => {
    if (!downPress || isDisabled) {
      return;
    }
    onDown();
  }, [downPress]);

  useEffect(() => {
    if (!upPress || isDisabled) {
      return;
    }
    onUp();
  }, [upPress]);

  useEffect(() => {
    onUpdateCommands(commands => ({...commands, onUp, onDown}));
  }, [onUp, onDown]);

  useEffect(() => {
    if (isDisabled) return;
    setTimeout(() => onUpdateCommands(commands => ({...commands, onUp, onDown})));
  }, [isDisabled, onUp, onDown]);

  useEffect(() => {
    if (!onChange) return;

    onChange(chars[selected].name);
  }, [selected]);

  const key = chars[selected];

  return (
    <div className={styles.keyContainer} style={style}>
      {!isDisabled && <img className={styles.arrowUpActive} src={ArrowUp} alt="Up" />}
      <li className={classNames(styles.numPicker, !isDisabled && styles.active)}>{key.name}</li>
      {!isDisabled && <img className={styles.arrowDownActive} src={ArrowDown} alt="Down" />}
    </div>
  );
}

export default TextNumbers;
